import { render } from "./OkurijoJissekiPage.vue?vue&type=template&id=1d0559ca"
import script from "./OkurijoJissekiPage.vue?vue&type=script&lang=js"
export * from "./OkurijoJissekiPage.vue?vue&type=script&lang=js"

import exportComponent from "/w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__